<template>
    <div class="feedback-detail">
        <div class="feedback-list">
            <div class="list-type">
                <span v-if="detailResult.feedbackType === 2" class="list-type-button button-green">{{detailResult.feedbackTypeName}}</span>
                <span v-if="detailResult.feedbackType === 1" class="list-type-button button-yellow">{{detailResult.feedbackTypeName}}</span>
                <span v-if="detailResult.feedbackType === 0" class="list-type-button button-red">{{detailResult.feedbackTypeName}}</span>
                <span v-if="detailResult.systems && detailResult.systems.length">
                    【<span v-for="(dt, dx) in detailResult.systems" :key="dx">{{dt.name.slice(0, dt.name.indexOf('系'))}}<span v-if="dx !== detailResult.systems.length-1">、</span></span>】
                    {{detailResult.feedbackContent}}
                </span>
                <span v-else>
                    【不涉及业务】
                    {{detailResult.feedbackContent}}
                </span>
            </div>
            <div class="img-list">
                <div class="inline-block" v-for="(item, index) in detailResult.files" :key="index">
                    <img v-if="item.fileType.indexOf('mp4') == -1" @click="showViewer(0, $event, [item.fileUri])" class="upload-img" :src="item.fileUri" alt="" />
                    <video :ref="'top'+index" v-if="item.fileType.indexOf('mp4') != -1" class="upload-img" autoplay>
                        <source :src="item.fileUri" type="video/mp4">
                        您的浏览器不支持Video标签。
                    </video>
                    <div v-if="item.fileType.indexOf('mp4') != -1" class="fullSceen" @click="clickAutoPlay(item.fileUri)"></div>
                </div>
                
            </div>
            <div class="list-date">
                <span>{{detailResult.createTime}}</span>
                <span v-if="detailResult.isReply" class="list-status">已回复</span>
                <span v-if="!detailResult.isReply" class="status">未回复</span>
            </div>
        </div>
        <div class="block" v-if="detailResult.replies && detailResult.replies.length" >
            <div class="mt" v-for="item in detailResult.replies" :key="item.id">
                <p class="read-text">回复：{{item.replyContent}}</p>
                <div class="img-list">
                    <div class="inline-block" v-for="(it, index) in item.files" :key="index">
                        <img v-if="it.fileType.indexOf('mp4') == -1" @click="showViewer(0, $event, [it.fileUri])"  class="upload-img" :src="it.fileUri" alt="" />
                        <video :ref="'bottom'+index" v-if="it.fileType.indexOf('mp4') != -1" class="upload-img" autoplay>
                            <source :src="it.fileUri" type="video/mp4">
                            您的浏览器不支持Video标签。
                        </video>
                        <div v-if="it.fileType.indexOf('mp4') != -1" class="fullSceen" @click="clickAutoPlay(it.fileUri)"></div>
                    </div>
                
                </div>
            </div>
        </div>
        <!-- <popupVideo :show="showVideo" :fileUrl="fileVideo" @close="close" /> -->
    </div>
</template>

<script>
    import api from '../../service/modules/feedback'
    import popupVideo from './components/popupVideo.vue'
    export default {
        name: 'FeedbackDetail',
        data() {
            return {
                showVideo: false,
                fileVideo: '',
                detailResult: {},
                userList: JSON.parse(localStorage.getItem('integrityInfo'))
            }
        },
        components: {
            popupVideo
        },
        computed: {

        },
        watch: {

        },
        methods: {
            detail() {
                let ajax, params;
                console.log(this.$route.params)
                if (this.$route.params.isAdmin == 'true') {
                    ajax = api.adminDetail
                    params = { feedbackId: this.$route.query.id }
                } else {
                    ajax = api.detail
                    params = { id: this.$route.query.id }
                }
                ajax(params).then(res => {
                    const { data } = res;
                    if (data.feedbackType === 0) {
                            data.feedbackTypeName = '账号问题'
                    } else if (data.feedbackType === 1) {
                        data.feedbackTypeName = '平台性能'
                    } else if (data.feedbackType === 2) {
                        data.feedbackTypeName = '产品意见'
                    }
                    this.detailResult = data;
                })
            },
            showViewer (index, event, imgList) {
                this.$ImagePreview({ images: imgList, startPosition: index, closeOnPopstate: true });
            },
            clickAutoPlay(index) {
                // console.log(index)
                this.$forceUpdate();
                // this.showVideo = true;
                // this.fileVideo = index;
                sessionStorage.setItem('videoUrl', index)
                this.$router.push('/previewVideo')
                // let video = this.$refs[index]
                // console.log(video[0])
                // if(video[0].requestFullscreen) {
                //     video[0].requestFullscreen();
                // } else if(video[0].mozRequestFullScreen) {
                //     video[0].mozRequestFullScreen();
                // } else if(video.webkitRequestFullscreen) {
                //     video[0].webkitRequestFullscreen();
                // } else if(video[0].msRequestFullscreen) {
                //     video[0].msRequestFullscreen();
                // }
            },
            close() {
                this.showVideo = false;
                this.fileUri = ''
            }
        },
        created() {
            this.detail()
        },
        mounted() {
        }
    }
</script>

<style lang="less" scoped>
    .feedback-detail{
        padding: 24px 16px;
        .fullSceen {
            position: absolute;
            top: 10px;
            left: 8px;
            width: 80px;
            height: 80px;
        }
        .inline-block {
            position: relative;
        }
        .feedback-list{
            // display: flex;
            // flex-wrap: wrap;
            .list-type{
                word-wrap:break-word
                .list-type-button{
                    display: inline-block;
                    padding: 4px 4px;
                    box-sizing: border-box;
                    border-radius: 2px;
                    text-align: center;
                    color: #36B374;
                    border: solid #36B374 0.5px;
                    font-size: 12.5px;
                    transform: scale(0.8);
                    margin-left: -6px;
                }
                .button-green{
                    color: #36B374;
                    border: solid #36B374 0.5px;
                }
                .button-yellow{
                    color: #FF8C19;
                    border: solid #FF8C19 0.5px;
                }
                .button-red{
                    color: #FF4D4D;
                    border: solid #FF4D4D 0.5px;
                }
                span:nth-child(2){
                    font-size: 14px;
                    color: #171A1D;
                    line-height: 28px;
                    word-wrap:break-word
                }
            }
            .list-date{
                width: 100%;
                display: flex;
                justify-content: space-between;
                font-size: 12px;
                margin-top: 16px;
                span:nth-child(1){
                    color: #A2A3A4;
                }
                .list-status{
                    color: #36B374;
                }
                .status {
                    color: #A2A3A4;
                }
            }
        }
        .img-list{
            display: flex;
            flex-wrap: wrap;
            .upload-img{
                margin-top: 10px;
                margin-left: 8px;
                width: 80px;
                height: 80px;
                border-radius: 4px;
            }
            // img:nth-child(3n+1){
            //     margin-left: 0;
            // }
        }
        .block{
            background: #F5F6F9;
            border-radius: 4px;
            padding: 16px;
            margin-top: 10px;
            .read-text{
                font-size: 14px;
                color: #171A1D;
                line-height: 22px;
            }
        }
        .mt {
            margin-top: 10px;
        }
    }
</style>